import { createFileRoute } from "@tanstack/react-router";

import { RobotsPage } from "../../workspaces/build/pages/RobotsPage";
import { useProjectId } from "../../shell/project";
import { prefetchForProject } from "../../lib/prefetch";

interface RobotsSearch {
  /** The robots as rows; the cards are the default and carry no word in the address. */
  readonly view?: "rows";
}

export const Route = createFileRoute("/_console/p/$org/$project/robots/")({
  validateSearch: (search: Record<string, unknown>): RobotsSearch =>
    search.view === "rows" ? { view: "rows" } : {},
  loader: ({ context: { queryClient }, params }) =>
    prefetchForProject(
      queryClient,
      params,
      import("../../workspaces/build/queries"),
      ({ robotCatalogQueries }, projectId) => {
        const reads = robotCatalogQueries(projectId);
        return Promise.all([
          queryClient.prefetchQuery(reads.access),
          queryClient.prefetchQuery(reads.bodies),
          queryClient.prefetchQuery(reads.development),
        ]);
      },
    ),
  component: ProjectRobotsRoute,
});

/** Every robot this person can see; each opens at its own address. */
function ProjectRobotsRoute() {
  const projectId = useProjectId();
  const { view } = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <RobotsPage
      projectId={projectId}
      view={view ?? "cards"}
      onViewChange={(next) =>
        void navigate({ search: next === "rows" ? { view: "rows" } : {}, replace: true })
      }
    />
  );
}
